import { useTranslation } from '@hfc/ui-core';

interface UseUrlHelperInterface {
  getCdnUrl: (url: string) => string;
  getBaseUrl: (url: string) => string;
  getEnrollmentAppUri: (url: string) => string;
  getIaFQuoteUrl: () => string;
  getSmallBusinessQuoteUrl: () => string;
  getMediCalQuoteUrl: () => string;
  getMedicareAppointmentUrl: () => string;
  getSmallBusinessConsultationLink: () => string;
}

export const useUrlHelper = (): UseUrlHelperInterface => {
  const { t } = useTranslation();

  const getBaseUrl = (url: string): string => {
    return `${import.meta.env.VITE_APP_BASE_URL}${url}`;
  };

  const getCdnUrl = (url: string): string => {
    return `${import.meta.env.VITE_APP_CDN_URL}${url}`;
  };

  function getEnrollmentAppUri (relativePath: string): string {
    return `${import.meta.env.VITE_ENROLLMENT_APP_URL}${relativePath}`;
  }

  const getIaFQuoteUrl = (): string => {
    return getBaseUrl(`/${t('links.individualAndFamilyQuote')}`);
  };

  const getSmallBusinessQuoteUrl = (): string => {
    return `${import.meta.env.VITE_ENROLLMENT_APP_URL}/small-business/application`;
  };

  const getMediCalQuoteUrl = (): string => {
    return `${import.meta.env.VITE_APP_BASE_URL}/medical-quote`;
  };

  const getMedicareAppointmentUrl = (): string => {
    return `${import.meta.env.VITE_ENROLLMENT_APP_URL}/medicare/appointment`;
  };

  const getSmallBusinessConsultationLink = (): string => {
    return `${import.meta.env.VITE_APP_SMALL_BUSINESS_QUOTE_REVIEW_LINK}`;
  };

  return {
    getBaseUrl,
    getCdnUrl,
    getEnrollmentAppUri,
    getIaFQuoteUrl,
    getSmallBusinessQuoteUrl,
    getMediCalQuoteUrl,
    getMedicareAppointmentUrl,
    getSmallBusinessConsultationLink,
  };
};
